var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 0C12.7171 0.000209042 16 3.28386 16 7.33398C16 11.3841 12.7171 14.6678 8.66699 14.668C4.74313 14.668 1.53896 11.586 1.34277 7.71094L1.33301 7.33398H0L2 4.66699L4 7.33398H2.66602C2.66602 10.6478 5.35313 13.334 8.66699 13.334C11.9807 13.3338 14.667 10.6477 14.667 7.33398C14.667 4.02027 11.9807 1.33419 8.66699 1.33398C8.29879 1.33398 8 1.0352 8 0.666992C8.00003 0.298812 8.2988 0 8.66699 0ZM9.32617 2.66699C9.69858 2.66724 9.99988 2.96708 10 3.33691V8.02051C10.001 8.19842 9.93085 8.36959 9.80469 8.49609L7.78027 10.5068C7.49732 10.7471 7.07151 10.7144 6.8291 10.4336C6.61279 10.1829 6.61279 9.81239 6.8291 9.56152L8.65137 7.74609V3.33691C8.65148 2.96692 8.95356 2.66699 9.32617 2.66699Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/HistoryIcon.414f327675c6d8bfb411403d611b28d8.svg";
export { ForwardRef as ReactComponent };